import { stat } from "fs"

export default {
    state: {
        user: null,
        auth_request: false,
        isAuthenticated: false,
        usuarios: [],
        marcador:"gocontact"
    },
    getters: {
        usuarios: (state) => state.usuarios,
        marcador:(state) => state.marcador
    },
    mutations: {
        AUTH_REQUEST: (state, payload) => state.auth_request = payload,
        AUTH: (state, payload) => state.isAuthenticated = payload,
        SET_USER: (state, payload) => state.user = payload,
        SET_USUARIOS: (state, payload) => state.usuarios = payload,
        SET_MARCADOR: (state, payload) => state.marcador = payload,
    },
    actions: {
        fetchUsuarios({commit}, payload) {
            this.dispatch('index', payload)
            .then((response) => {
              commit('SET_USUARIOS', response.datos)
            })
        },
        login({commit}, user) {
            return new Promise((resolve, reject) => {
                commit('AUTH_REQUEST', true)
                this.state.api.post('login', user)
                .then(response => {
                    commit('AUTH', true);
                    commit('SET_USER', response.data.user)
                    commit('SET_MARCADOR', response.data.marcador)
                    const token = response.data.access_token
                    this.state.api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                    localStorage.setItem('token', token)
                    localStorage.setItem('user', JSON.stringify(response.data.user))
                    localStorage.setItem('marcador', response.data.marcador)
                    resolve(response)
                }).catch(err => {
                    localStorage.removeItem('token')
                    reject(err)
                })
                .then(() => {
                    commit('AUTH_REQUEST', false)
                })
            })
        },
        logout({commit}) {
          return new Promise((resolve) => {
            commit('AUTH', false);
            commit('SET_USER', null)
            localStorage.removeItem('token')
            delete this.state.api.defaults.headers.common['Authorization']
            resolve()
          })
        },
        getAuthUser({commit}) {
            let request = new Promise((resolve, reject) => {
                commit('AUTH_REQUEST', true)
                this.state.api.get('login/me')
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                    reject(err)
                })
                .then(() => {
                    commit('AUTH_REQUEST', false)
                })
            })

            request.then((response) => {
                this.dispatch('user/refreshUser', response)
                localStorage.setItem('user', JSON.stringify(response))
            })
        },
        refreshUser({commit}, user) {
            commit('SET_USER', user);
        }
    }
}